import { map, tap } from 'rxjs';
import { TermsOfUseService } from './../services/terms-of-use.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { ROLES } from '../../../permissions/constants/roles';

@Injectable({
    providedIn: 'root'
})
export class TermsOfUseGuard  {

    constructor(private termsOfUseService: TermsOfUseService, private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivateRouteOrChild(route, state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivateRouteOrChild(childRoute, state);
    }

    private canActivateRouteOrChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (state.url === '/tos' || (state.url !== '/tos' && this.router.url === '/tos')) {
            return true;
        }
        const termsOfUseResult = this.termsOfUseService.getTermsOfUse();

        return termsOfUseResult.response$.pipe(
            map(tos => !tos.showTermsOfUseOnLogin),
            tap(dontShowTermsOfUse => {
                var showLightWeightTerms = this.authService.hasRole([ROLES.Stakeholder, ROLES.Immigration, ROLES.Tax, ROLES.Collaborator, ROLES.Supplier]);
                const parsedUrl = new URL(window.location.href);
                const returnUrl = parsedUrl.pathname+parsedUrl.search+parsedUrl.hash;

                if(!dontShowTermsOfUse) {
                    let queryParams: any = {};

                    if (returnUrl)
                        queryParams.returnUrl = returnUrl;

                    if (showLightWeightTerms)
                        queryParams.lightWeightTerms = true;

                    this.router.navigate(['/tos'], { queryParams });
                }
            }),
        );

    }

}
